export default __webpack_public_path__ + "static/media/cadeados.33c3db95.png";